import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, TrendingUp, Mail, Lock } from 'lucide-react';

interface LeadCardTotalPorVideoProps {
  videoId: string;
  total: number;
  emailCount: number;
  passwordCount: number;
  growth: number;
}

export function LeadCardTotalPorVideo({ 
  total, 
  emailCount, 
  passwordCount, 
  growth 
}: LeadCardTotalPorVideoProps) {
  useLanguage();
  const emailPercentage = Math.round((emailCount / total) * 100);
  const passwordPercentage = Math.round((passwordCount / total) * 100);

  return (
    <Card className="rounded-[14px] shadow-sm hover:shadow-md transition-shadow min-h-[160px]">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {translateInterfaceText("Total de Leads do Vídeo")}</CardTitle>
        <Users className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="flex items-baseline gap-2 mb-4">
          <p className="text-3xl font-bold">{total.toLocaleString(getInterfaceLanguage())}</p>
          <span className="text-sm font-medium text-green-600 flex items-center gap-1">
            <TrendingUp className="h-3 w-3" />
            +{growth}%
          </span>
        </div>
        
        <div className="space-y-2 pt-3 border-t">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <Mail className="h-3.5 w-3.5 text-blue-500" />
              <span className="text-muted-foreground">{translateInterfaceText("Captura com E-mail")}</span>
            </div>
            <span className="font-semibold">
              {emailCount} ({emailPercentage}%)
            </span>
          </div>
          
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <Lock className="h-3.5 w-3.5 text-purple-500" />
              <span className="text-muted-foreground">{translateInterfaceText("Captura com Senha")}</span>
            </div>
            <span className="font-semibold">
              {passwordCount} ({passwordPercentage}%)
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
